module.exports = "/_next/static/images/WebFirstProcess-9ac0b4ce89e4d64e1e9af57246cd6d6f.png";